'use es6'; // The user attribute that indicates we should start the tour

export const SHOULD_SHOW_FREE_LP_ONBOARDING_TOUR = 'ContentEditorUI.userSettings.shouldStartFreeLPOnboardingTour'; // The user attribute that holds which tours the user has seen

export const SEEN_STATE_ATTRIBUTES = 'ContentEditorUI.userSettings.seenStateObj'; // This is the key which is in the above attribute object that corresponds to
// whether the user has seen the free LP onboarding tour

export const HAS_SEEN_FREE_LP_ONBOARDING_TOUR_KEY = 'sawFreeLPOnboardingTour'; // The list of user attributes we want to fetch from the API

export const USER_ATTRIBUTES_TO_FETCH = [SEEN_STATE_ATTRIBUTES, SHOULD_SHOW_FREE_LP_ONBOARDING_TOUR];
export const FINISHED_STEP = 'finish';